const getNamedContactsLink = () => {
    return `${window.SAC_BASE_URL}/named-contact`;
};

export { getNamedContactsLink };
